// webpack lazy loading
// https://webpack.js.org/guides/lazy-loading/#src/components/Sidebar/Sidebar.jsx
//
let weixinPromise = null
let wxloginPromise = null

let asyncInsertScript = (src) => {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script')
    let body = document.getElementsByTagName('body')[0]

    let load = () => {
      console.log('load', src)
      resolve()
    }

    let error = () => {
      console.log('error', src)
      reject()
    }

    script.addEventListener ? script.addEventListener('load', load, !1) : script.attachEvent('onload', load)
    script.addEventListener ? script.addEventListener('error', error, !1) : script.attachEvent('onerror', error)

    script.type = 'text/javascript'
    script.async = !0
    body.appendChild(script)
    script.src = src
  })
}

export async function lazyload(packageName) {
  async function load(packageName) {
    switch (packageName) {
      case 'weixin':
        if (!weixinPromise) {
          weixinPromise = asyncInsertScript('//res.wx.qq.com/open/js/jweixin-1.2.0.js')
        }
        return weixinPromise
      case 'wxlogin':
        if (!weixinPromise) {
          wxloginPromise = asyncInsertScript('//res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js')
        }
        return wxloginPromise
        /* beautify preserve:start */
      case 'vue-numeric':
        return import(/* webpackMode: 'eager' */ 'vue-numeric')
      case 'jquery':
        return import(/* webpackChunkName: 'vendor.uploads' */ 'jquery')
      case 'blueimp-file-upload':
        return import(/* webpackChunkName: 'vendor.uploads' */ 'blueimp-file-upload')
      case 'plupload':
        return import(/* webpackChunkName: 'vendor.uploads' */ 'plupload')
      case 'qiniu':
        return import(/* webpackChunkName: 'vendor.uploads' */ 'qiniu-js')
      case 'simple-ajax-uploader':
        return import(/* webpackChunkName: 'vendor.uploads' */ 'simple-ajax-uploader')
      case 'chartkick':
        await import(/* webpackChunkName: 'vendor.charts' */ 'chart.js')
        return import(/* webpackChunkName: 'vendor.charts' */ 'chartkick')
      default:
        return import(packageName)
      /* beautify preserve:end */
    }
  }

  return load(packageName).catch(e => {
    window.alert(process.env.LOCALE === 'zh-cn' ? '当前网络出现问题，请重新刷新页面' : 'Network Error')
  })
}



// WEBPACK FOOTER //
// ./src/assets/scripts/lazy-load-module.js